import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Paper, Alert } from '@mui/material';
import { formatDate, formatPrice } from '../../utils/helpers';
import EventStatus from '../EventDetails/EventStatus';
import DataTable from '../shared/DataTable';

export default function TeamEvents() {
  const location = useLocation();
  const navigate = useNavigate();
  const team = location.state?.team;

  if (!team) {
    return (
      <div className="container my-5">
        <Alert severity="error">No data available</Alert>
      </div>
    );
  }

  const handleRowClick = (row) => {
    navigate(`/event-details/${row.id}`);
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      cell: row => <span className="font-bold">{row.id}</span>,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Event Cost',
      selector: row => row.spend_value || 0,
      sortable: true,
      format: row => formatPrice(row.spend_value || 0),
    },
    {
      name: 'Start Date',
      selector: row => row.start_date,
      sortable: true,
      format: row => formatDate(row.start_date),
    },
    {
      name: 'End Date',
      selector: row => row.end_date,
      sortable: true,
      format: row => formatDate(row.end_date),
    },
    {
      name: 'Status',
      cell: row => (
        <EventStatus 
          size='xs' 
          startDate={row.start_date} 
          endDate={row.end_date} 
          eventId={row.id}
          spend_value={row.spend_value || 0}
          isOrganization={row.organization_id ? true : false}
          tov_export={row.tov_export}
        />
      ),
    },
  ];

  return (
    <div className='container mt-6'>
      <Paper className="my-5">
        <h2 className="text-2xl font-semibold p-6 text-purpleColor">
          {team.name} {team.isDivision ? 'Division' : 'Team'} Events
        </h2>
        {(!team.events || team.events.length === 0) ? (
          <Alert severity="info" className="m-4">
            No events found for this {team.isDivision ? 'division' : 'team'}
          </Alert>
        ) : (
          <DataTable
            columns={columns}
            data={team.events}
            searchable={true}
            searchPlaceholder="Search events..."
            searchFields={['id', 'name']}
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 20, 30, 50]}
            onRowClick={handleRowClick}
            customStyles={{
              headRow: {
                style: {
                  backgroundColor: '#f8fafc',
                  borderBottom: '2px solid #e2e8f0',
                },
              },
              headCells: {
                style: {
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#1e293b',
                  padding: '16px',
                },
              },
              cells: {
                style: {
                  fontSize: '14px',
                  color: '#475569',
                  padding: '16px',
                },
              },
              rows: {
                style: {
                  minHeight: '52px',
                  '&:nth-of-type(odd)': {
                    backgroundColor: '#f8fafc',
                  },
                  '&:hover': {
                    backgroundColor: '#f1f5f9',
                    cursor: 'pointer',
                  },
                },
              },
            }}
          />
        )}
      </Paper>
    </div>
  );
}